import { gql } from '@apollo/client';

export const GET_ALL_PLATFORM_NEWS_QUERY = gql`
  fragment CommonPlatformNews on ConciergePlatformNews {
    id
    title
    subtitle
    bodyText
    locale
    published_at
    mainImage {
      url
      formats
      id
    }
  }

  query GetAllPlatformNews {
    conciergePlatformNews(sort: "published_at:desc") {
      ...CommonPlatformNews
      localizations {
        ...CommonPlatformNews
      }
    }
  }
`;
